module.exports = __webpack_public_path__ + "static/media/CXL_rainforest.65916ee3.png";